export const preTestCollection = 'preTests';
export const postTestCollection = 'postTests';

export const questions: IQuestion[] = [
  {
    question: `วิธีที่แฮกเกอร์ใช้หลักการจิตวิทยา คำพูด หรือการกระทำ เพื่อหลอกล่อเหยื่อที่จะทำการแฮก คือวิธีการใด`,
    choices: [
      'Impersonation',
      'Social Engineering',
      'Man in The Middle',
      'Tailgating',
    ],
    answer: 1,
  },
  {
    question: `มัลแวร์ชนิดใด มีความสามารถในการสอดส่องข้อมูล และเก็บข้อมูลจากเป้าหมาย`,
    choices: ['Adware', 'Ransomware', 'Spyware', 'Backdoors'],
    answer: 2,
  },
  {
    question: `มัลแวร์ที่ทำหน้าที่คอยเปิดหน้าต่างโฆษณาตามเว็บไซต์ หรือตามไฟล์ในเครื่องคอมพิวเตอร์คือมัลแวร์ชนิดใด`,
    choices: ['Adware', 'Ransomware', 'Spyware', 'Backdoors'],
    answer: 0,
  },
  {
    question: `ข้อใดคือข้อมูลที่ถูกต้องของ “http” กับ “https”`,
    choices: [
      `“http” มีความปลอดภัยมากกว่า “https”`,
      `“https” มีความปลอดภัยมากกว่า “http”`,
      `หมายเลขพอร์ตของ “http” คือ 443 , ของ “https” คือ 80`,
      `“https” ไม่มีการเข้ารหัสข้อมูลระหว่างส่ง เหมือน “http”`,
    ],
    answer: 1,
  },
  {
    question: `วิธีที่แฮกเกอร์ตั้ง Access Point เลียนแบบ Router ของเป้าหมาย เพื่อหลอกล่อเหยื่อบางรายให้เชื่อมต่อผิดเข้ามา คือวิธีการใด`,
    choices: [`Social Twins`, `Dual Twins`, `Evil Twins`, `Attack Twins`],
    answer: 2,
  },
  {
    question: `การป้องกัน Tailgating หรือการแอบเดินตามผู้ที่มิสิทธิ์เข้าประตูเข้าไปด้วย ป้องกันได้ด้วยวิธีใด`,
    choices: [`Mantraps`, `Firewall`, `Anti cheat`, `Man Defender`],
    answer: 0,
  },
  {
    question: `หน้าที่ของ Firewall คืออะไร`,
    choices: [
      `เป็นเบราเซอร์หนึ่ง ใช้ในการเข้าเว็บไซต์`,
      `เป็นกำแพงระบายความร้อนของแผงวงจรคอมพิวเตอร์`,
      `เป็นกำแพงกรองข้อมูลที่ไม่ปลอดภัยของเครื่องคอมพิวเตอร์`,
      `เป็นระบบปฎิบัติการหนึ่ง คล้ายกับพวก Windows , Linux`,
    ],
    answer: 2,
  },
  {
    question: `ข้อใดไม่ใช่หลักการยืนยันตัวตนของวิธี Multi-Factor Authentication`,
    choices: [
      `Something you know ( สิ่งที่คุณรู้ )`,
      `Something you have ( สิ่งที่คุณมี )`,
      `Something you are ( สิ่งที่เป็นคุณ )`,
      `Something you will be ( สิ่งที่คุณจะเป็น )`,
    ],
    answer: 3,
  },
  {
    question: `Cross-site Scripting คืออะไร`,
    choices: [
      `URL Link ที่แฮกเกอร์วางระบบบางอย่างใน Script แนบเอาไว้`,
      `Script ที่ใช้ข้ามฝั่งระบบปฎิบัติการ`,
      `กุญแจ Backdoors ในการเข้าคลังข้อมูลจากทางลับในระบบ`,
      `การเขียน Script ในรูปแบบกากบาท`,
    ],
    answer: 0,
  },
  {
    question: `การโจมตีของแฮกเกอร์ ที่ใช้การส่งข้อมูลจำนวนมากเข้าไปหาเป้าหมาย จนทำให้เกิดดาวน์ไทม์ คือวิธีการใด`,
    choices: [
      `Brute Force Attack`,
      `Distribute Denial of Service Attack`,
      `Birthday Attack`,
      `Bluejacking Attack`,
    ],
    answer: 1,
  },
  {
    question: `Biometric Authentication คืออะไร`,
    choices: [
      `การยืนยันตัวตน โดยใช้ความรู้ศาสตร์ชีวภาพของผู้ยืนยันตัวตน`,
      `การยืนยันตัวตน โดยใช้วิธีการปลดล็อกรหัสผ่านแบบตัวเลข`,
      `การยืนยันตัวตน โดยใช้วิธีการใส่รหัสผ่านแบบตัวหนังสือ`,
      `การยืนยันตัวตน โดยใช้ข้อมูลชีวภาพของผู้ยืนยัน`,
    ],
    answer: 3,
  },
  {
    question: `AAA model คืออะไร`,
    choices: [
      `ขนาดของถ่านอัลคาไลน์ ใช้สำหรับอุปกรณ์อิเล็กทรอนิกส์`,
      `การตรวจสอบเอกลักษณ์ของผู้ใช้ ได้แก่ Authentication Authorization Accounting`,
      `รูปแบบการโจมตีของแฮกเกอร์ ย่อมาจากคำว่า Attack All Around`,
      `องค์กรณ์ American Automobile Association`,
    ],
    answer: 1,
  },
  {
    question: `CIA Triad ย่อมาจากอะไร และหมายถึงอะไร`,
    choices: [
      `Central Intelligence Agency  สำนักงานข่าวกรองกลาง`,
      `Central Implement Attack  การโจมตีเข้าสู่ศูนย์กลางระบบ`,
      `Confidentiality Integrity Availability  หลักพื้นฐานความปลอดภัยด้านสารสนเทศ`,
      `Condition Identity Authentication   การยืนยันตัวตนโดยใช้เงื่อนไขอัตลักษณ์`,
    ],
    answer: 2,
  },
  {
    question: `ทฤษฎีที่จะอนุญาตให้ผู้ใช้เข้าสู่ระบบ หรือจำกัดการเข้าถึงข้อมูลได้เฉพาะตามภาระหน้าที่และความรับผิดชอบ คือทฤษฎีใด`,
    choices: [
      `Social Engineering`,
      `Human Analytics`,
      `Impersonation`,
      `Least Privilege`,
    ],
    answer: 3,
  },
  {
    question: `ระบบการควบคุมชนิดใด มีหน้าที่รับผิดชอบการสร้างกลไกตรวจสอบข้อผิดพลาดของข้อมูลในเฟรมข้อมูล`,
    choices: [`MAC`, `DAC`, `RBAC`, `DDAC`],
    answer: 0,
  },
  {
    question: `Cloud Service ประเภทใด เป็นประเภทที่ดีที่สุดสำหรับผู้พัฒนา ในการทำเว็บไซต์ หรือแอปพลิเคชั่น`,
    choices: [`AppS`, `PaaS`, `DDoS`, `API`],
    answer: 1,
  },
  {
    question: `ข้อใดคือตัวอย่างรหัสผ่าน ที่มีความปลอดภัยมากที่สุด`,
    choices: [`4778856`, `security123`, `aSecuriTy4821.`, `cybersecurity`],
    answer: 2,
  },
  {
    question: `ข้อใดไม่ใช่วิธีการป้องกัน DDoS Attack`,
    choices: [
      `ขยาย Bandwidth เพิ่ม`,
      `ใช้บริการ Content Delivery Network`,
      `ตั้งขีดจำกัดคำขอ Server`,
      `ใช้ทฤษฎี Least Privilege`,
    ],
    answer: 3,
  },
];
